import {
  Button,
  Checkbox,
  DateRangePicker,
  FAIcon,
  MonthPicker,
  Select,
  Toggle,
  UserSelect,
} from '@/components_deprecated'
import { Field, Form, Section } from '@/modules/companies'
import { responsiveExportGridAreas } from '@/modules/companies/util'
import {
  useExportFormatOptions,
  useExportOptions,
} from '@/modules/exports/hooks'
import { handleDateRangeChange } from '@/utils/date/handleDateRangeChange'
import { ComponentSwitch } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { isMobile } from 'react-device-detect'
import { ExportFormat } from '../../../../exports'
import { useExportInfringementsForm } from '../../hooks'

export const ExportInfringementsCard: React.FC = () => {
  const translations = useTranslate({
    exportAll: 'infringements.export-infringement-data',

    period: 'common.period',
    exportType: 'common.type',
    exportOption: 'common.export-type',
    exportFormat: 'common.export-format',
    hours: 'common.hours',
    diet: 'common.diet',

    export: 'common.export',
    user: 'common.user',
    exportCompany: 'infringements.export.all',
  })

  const exportFormats = useExportFormatOptions([
    ExportFormat.EXCEL_FLAT,
    ExportFormat.PDF_SALARY,
    ExportFormat.POWEROFFICE,
    ExportFormat.TRIPLETEX,
    ExportFormat.TWENTYFOUR_SEVEN_OFFICE,
    ExportFormat.VISMA,
    ExportFormat.VISMA_NEW,
  ])

  const { loading, form, errors, submit, updateForm, handleExport, handler } =
    useExportInfringementsForm()

  const exportOptions = useExportOptions()

  const areas = !isMobile
    ? `
        ${responsiveExportGridAreas(
          true,
          false,
          form.exportMass ? 'infringement' : undefined
        )}
        'selectAll selectAll selectAll'
      `
    : `
        ${responsiveExportGridAreas(true, true)}
        'selectAll'
        'selectAll'
      `

  return (
    <>
      <Section
        header={translations.exportAll}
        loading={loading}
        actions={
          <Toggle
            value={form.useDateRange}
            thumbBackground="secondary"
            iconMode="svg"
            localOnIconProps={{
              icon: 'calendar-selection',
              fill: form.useDateRange ? 'white' : 'primary',
            }}
            localOffIconProps={{
              icon: 'calendar-month',
              fill: !form.useDateRange ? 'white' : 'primary',
            }}
            onChange={() => handler('useDateRange')(!form.useDateRange)}
          />
        }
      >
        <Form
          grid={{
            columns: !isMobile ? '3fr 2fr' : '1fr',
            areas: areas,
          }}
        >
          <Field area="month">
            <label>{translations.period}</label>
            <ComponentSwitch>
              <ComponentSwitch.Case case={form.useDateRange}>
                <DateRangePicker
                  value={[form.dateStart, form.dateEnd]}
                  grayed={false}
                  onChange={handleDateRangeChange(updateForm)}
                />
              </ComponentSwitch.Case>

              <ComponentSwitch.Case default>
                <MonthPicker
                  value={form.month}
                  light
                  futureYears={0}
                  noYearCycle
                  onChange={handler('month')}
                />
              </ComponentSwitch.Case>
            </ComponentSwitch>
          </Field>

          <Field area="exportOption">
            <label>{translations.exportOption}</label>
            <Select
              value={form.exportOption}
              options={exportOptions}
              fullWidth
              height="3.875rem"
              onChange={handler('exportOption')}
            />
          </Field>

          <Field area="selectAll">
            <label>{translations.exportCompany}</label>
            <div>
              <Checkbox
                checked={form.exportMass}
                onChange={() => {
                  updateForm({ exportMass: !form.exportMass, user: '' })
                }}
                label={translations.exportCompany}
                inline
              />
            </div>
          </Field>

          {!form.exportMass && (
            <Field area="user">
              <label>{translations.user}</label>
              <UserSelect
                value={form.user ?? ''}
                error={errors.user}
                fullWidth
                dropdownPageName="activities"
                height="3.875rem"
                onChange={handler('user')}
              />
            </Field>
          )}
          {form.exportMass && (
            <Field area="exportFormat">
              <label>{translations.exportFormat}</label>
              <Select
                value={form.exportFormat}
                options={exportFormats}
                fullWidth
                height="3.875rem"
                onChange={handler('exportFormat')}
              />
            </Field>
          )}
          <Field alignRight className="submit" area="button">
            <Button
              type="submit"
              onClick={submit(handleExport)}
              disabled={loading}
            >
              <FAIcon
                icon="download"
                type="light"
                $color="primary"
                margin="0 0.5ch 0 0"
              />
              {translations.export}
            </Button>
          </Field>
        </Form>
      </Section>
    </>
  )
}
